import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as orderApi from '../services/orderAnalysisApi';
import Button from '../components/Button';
import { DesignNeedPanel } from './OrderAnalysisPage';

/** Full page for "Design Need To Complete Pending Order": size cards, and under a size card
 * the designs (with order list) that still have to be produced to complete the pending orders. */
export default function DesignNeedPage() {
  const navigate = useNavigate();
  const [groups, setGroups] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let dead = false;
    orderApi.getPendingOrderGroups()
      .then((g) => { if (!dead) setGroups(g); })
      .catch((e) => { if (!dead) setError((e && e.message) || 'Could not load pending orders.'); });
    return () => { dead = true; };
  }, []);

  const noBatch = (l) => !l.batch_shade || String(l.batch_shade).trim().toUpperCase() === '0/A';
  const designCount = groups
    ? new Set(groups.flatMap((g) => g.lines.filter(noBatch).map((l) => `${l.size_name}|${l.design_name}`))).size
    : 0;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)', flexWrap: 'wrap', marginBottom: 'var(--space-4)' }}>
        <Button variant="secondary" onClick={() => navigate('/order-analysis')}>{'\u2190'} Back</Button>
        <div>
          <h1 style={{ margin: 0 }}>Design Need To Complete Pending Order</h1>
          {groups && (
            <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)' }}>
              {groups.length} pending orders &middot; {designCount} design/size combinations still to be produced
            </div>
          )}
        </div>
      </div>
      {error && <p style={{ color: 'var(--color-danger)' }}>{error}</p>}
      {!groups && !error && <p style={{ color: 'var(--color-text-secondary)' }}>Loading{'\u2026'}</p>}
      {groups && <DesignNeedPanel groups={groups} />}
    </div>
  );
}
